export const GOOGLE_SITE_KEY = "6Ld7TeQpAAAAAGKlNFAlACk-XjhSWZs9sFB0CZhr";
